module.exports = __webpack_public_path__ + "static/media/camping-03.d3e67a38.jpg";